import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { styles } from './styles';
import DashboardHeader from './DashboardHeader';
import VehicleStatusPanel from './VehicleStatusPanel';
import TripDetailsPanel from './TripDetailsPanel';
import TripsWeeklyChart from './TripsWeeklyChart';
import ActiveVehiclesChart from './ActiveVehiclesChart';
import AvgTripsChart from './AvgTripsChart';
import PerformanceStatus from './PerformanceStatus';
import DJBSummerPlan from './DJBSummerPlan';
import React, { useEffect } from 'react';
import { AnalyticsDashoardAction } from '../../actions/AnalyticsDashboard';
import { decryptAesObj } from "../CommonComponents/AESencryptdecrypt";
import EmergeancyPerformanceStatus from './EmergencyPerformanceStatus';
import "./style.css"
import TripsYearlyChart from './TripsYearlyChart';
import TripsMonthlyChart from './TripsMonthlyChart';
import { SiteAction } from "../../actions/site";
const LoadingOverlay = ({ loading, children }) => (
    <Box sx={{ position: 'relative' }}>
        {loading && (
            <Box sx={{
                position: 'absolute', inset: 0, zIndex: 10,
                display: 'flex', justifyContent: 'center', alignItems: 'center',
                borderRadius: 2,
                background: 'rgba(255,255,255,0.6)',
            }}>
                <CircularProgress size={36} thickness={4} sx={{ color: '#1a90ff' }} />
            </Box>
        )}
        {children}
    </Box>
);

const AnalyticsDashboard = () => {
    const [data, setData] = React.useState(null);
    const [lowCoverageData, setLowCoverageData] = React.useState(null);
    const [lowCoveragePage, setLowCoveragePage] = React.useState(0);
    const [lowCoveragePageSize, setLowCoveragePageSize] = React.useState(10);
    const [performanceData, setPerformanceData] = React.useState(null);
    const [performanceTab, setPerformanceTab] = React.useState({ label: "Today", key: "TODAY" });
    const [performancePage, setPerformancePage] = React.useState(0);
    const [performancePageSize, setPerformancePageSize] = React.useState(10);
    const [summerPlanData, setSummerPlanData] = React.useState(null);
    const [scheduledVsActualData, setScheduledVsActualData] = React.useState(null);
    const [summerPlanFilter, setSummerPlanFilter] = React.useState('LAST_7_DAYS');
    const [weeklyData, setWeeklyData] = React.useState(null);
    const [dataLoading, setDataLoading] = React.useState(true);
    const [weeklyLoading, setWeeklyLoading] = React.useState(true);
    const [lowCoverageLoading, setLowCoverageLoading] = React.useState(true);
    const [performanceLoading, setPerformanceLoading] = React.useState(true);
    const [summerPlanLoading, setSummerPlanLoading] = React.useState(true);
    const [unverifiedDplData, setUnverifiedDplData] = React.useState(null);
    // Add these new states
    const [emergencyPerformanceData, setEmergencyPerformanceData] = React.useState(null);
    const [emergencyPerformanceTab, setEmergencyPerformanceTab] = React.useState({ label: "Today", key: "TODAY" });
    const [emergencyPerformancePage, setEmergencyPerformancePage] = React.useState(0);
    const [emergencyPerformanceLoading, setEmergencyPerformanceLoading] = React.useState(true);
    const [perfPage, setPerfPage] = React.useState(0);
    const [perfPageSize, setPerfPageSize] = React.useState(10);
    const [permissionAccess, setPermissionAccess] = React.useState(
        decryptAesObj(localStorage?.getItem("data")),
    );
    const [monthlyData, setMonthlyData] = React.useState(null);
    const [yearlyData, setYearlyData] = React.useState(null);
    const [monthlyLoading, setMonthlyLoading] = React.useState(true);
    const [yearlyLoading, setYearlyLoading] = React.useState(true);
    const [emergencySites, setEmergencySites] = React.useState([]);
    const [selectedMonthlyEmergencySite, setSelectedMonthlyEmergencySite] = React.useState(null);
    const [selectedYearlyEmergencySite, setSelectedYearlyEmergencySite] = React.useState(null);

    const isDashboardVisible = permissionAccess?.menuVisiblity?.find(
        item => item.name === "ANALYTICS_DASHBOARD"
    )?.isVisible;

    const isTripDashboardVisible = permissionAccess?.subMenuVisibilty?.find(
        item => item.name === "TRIP_DASHBOARD"
    )?.isVisible;

    console.log("permissionAccess", isTripDashboardVisible)

    useEffect(() => {
        const companyId = decryptAesObj(localStorage.getItem("data")).companyId;

        async function fetchData() {
            setDataLoading(true);
            try {
                const response = await AnalyticsDashoardAction.getVehcileTripsAnalytics({ companyId });
                if (response && response.responseCode === 200 && response.data) {
                    const d = response.data;
                    const msH = d.tankerTypeStats.MS_HIRED;
                    const dept = d.tankerTypeStats.DEPARTMENTAL;
                    setData({
                        vehicleStatus: {
                            msHiredTotal: d.totalMsHiredWithWorkorder,
                            departmentalTotal: d.totalDepartmentalVehicles,
                            msHiredActiveToday: msH.vehicles.today,
                            msHiredActiveYesterday: msH.vehicles.yesterday,
                            msHiredActiveMonthly: msH.vehicles.monthly,
                            departmentalActiveToday: dept.vehicles.today,
                            departmentalActiveYesterday: dept.vehicles.yesterday,
                            departmentalActiveMonthly: dept.vehicles.monthly,
                            activeToday: msH.vehicles.today + dept.vehicles.today,
                            activeYesterday: d.total.vehicles.yesterday,
                            activeMonthly: d.total.vehicles.monthly,
                        },
                        tripDetails: {
                            msHiredVehiclesToday: msH.vehicles.today,
                            msHiredVehiclesYesterday: msH.vehicles.yesterday,
                            msHiredVehiclesMonthly: msH.vehicles.monthly,
                            msHiredTripsToday: msH.trips.today,
                            msHiredTripsYesterday: msH.trips.yesterday,
                            msHiredTripsMonthly: msH.trips.monthly,

                            departmentalVehiclesToday: dept.vehicles.today,
                            departmentalVehiclesYesterday: dept.vehicles.yesterday,
                            departmentalVehiclesMonthly: dept.vehicles.monthly,
                            departmentalTripsToday: dept.trips.today,
                            departmentalTripsYesterday: dept.trips.yesterday,
                            departmentalTripsMonthly: dept.trips.monthly,
                            totalTripsToday: d.total.trips.today,
                            totalTripsYesterday: d.total.trips.yesterday,
                            totalTripsMonthly: d.total.trips.monthly,
                            totalVehiclesToday: d.total.vehicles.today,
                            totalVehiclesYesterday: d.total.vehicles.yesterday,
                            totalVehiclesMonthly: d.total.vehicles.monthly,
                        },
                    });
                }
            } finally {
                setDataLoading(false);
            }
        }

        async function fetchWeeklyTripComparison() {
            setWeeklyLoading(true);
            try {
                const response = await AnalyticsDashoardAction.getWeeklyTripComparison();
                console.log("weekly comparison response", response);
                if (response && response.responseCode === 200 && response.data) {
                    const raw = response.data.weeklyComparison;
                    setWeeklyData({
                        weeklyTripComparison: raw.map(d => ({
                            dayLabel: d.day,
                            currentWeekTrips: d.currentTrips,
                            prevWeekTrips: d.previousTrips,
                        })),

                        weeklyActiveVehicles: raw.map(d => ({
                            dayLabel: d.day,
                            currentWeekVehicles: d.currentVehicles,
                            prevWeekVehicles: d.previousVehicles,
                        })),

                        weeklyAvgTripsPerVehicle: raw.map(d => ({
                            dayLabel: d.day,
                            avgCurrentWeek: d.currentAvg,
                            avgPrevWeek: d.previousAvg,
                        })),
                    });
                }
            } finally {
                setWeeklyLoading(false);
            }
        }

        async function fetchDataLowCoverageVehicles() {
            setLowCoverageLoading(true);
            try {
                const response = await AnalyticsDashoardAction.getLowCoverageVehicles();
                if (response && response.responseCode === 200 && response.data) {
                    setLowCoverageData(response.data);
                }
            } finally {
                setLowCoverageLoading(false);
            }
        }

        fetchData();
        fetchWeeklyTripComparison();
        fetchDataLowCoverageVehicles();

        const interval = setInterval(() => {
            fetchData();
        }, 5 * 60 * 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        async function fetchPerformance() {
            setPerformanceLoading(true);
            try {
                const response = await AnalyticsDashoardAction.getPerformanceStatus({
                    dateRange: performanceTab.key,
                    fromDate: performanceTab.fromDate,   // will be undefined for normal tabs
                    toDate: performanceTab.toDate,
                });
                if (response && response.responseCode === 200 && response.data) {
                    setPerformanceData(response.data);
                } else {
                    setPerformanceData([]);
                }
            } finally {
                setPerformanceLoading(false);
            }
        }
        fetchPerformance();
    }, [performanceTab]);

    useEffect(() => {
        async function fetchSummerPlan() {
            setSummerPlanLoading(true);
            try {
                const companyId = decryptAesObj(localStorage.getItem("data")).companyId;
                const response = await AnalyticsDashoardAction.getSummerPlan({
                    companyId,
                    dateRange: summerPlanFilter,
                });
                if (response && response.responseCode === 200 && response.data) {
                    setSummerPlanData(response.data);
                }
            } finally {
                setSummerPlanLoading(false);
            }
        }

        async function fetchScheduledVsActualTrips() {
            setSummerPlanLoading(true);
            try {
                const companyId = decryptAesObj(localStorage.getItem("data")).companyId;
                const response = await AnalyticsDashoardAction.getScheduledVsActualTrips({
                    companyId,
                    dateRange: summerPlanFilter,
                });
                console.log("responseresponseresponse", response.data)
                if (response && response.responseCode === 200 && response.data) {
                    setScheduledVsActualData(response.data);
                }
            } finally {
                setSummerPlanLoading(false);
            }
        }

        async function fetchUnverifiedDPLs() {
            try {
                const response = await AnalyticsDashoardAction.getUnverifiedDPLs();
                if (response && response.responseCode === 200 && response.data) {
                    setUnverifiedDplData(response.data);
                }
            } catch (e) {
                console.log("unverified dpl error", e);
            }
        }

        fetchScheduledVsActualTrips();
        fetchUnverifiedDPLs();
        fetchSummerPlan()
    }, []);

    useEffect(() => {
        async function fetchEmergencyPerformance() {
            setEmergencyPerformanceLoading(true);
            try {
                const response = await AnalyticsDashoardAction.getEmergencyPerformanceStatus({
                    dateRange: emergencyPerformanceTab.key,
                    fromDate: emergencyPerformanceTab.fromDate,   // undefined for normal tabs
                    toDate: emergencyPerformanceTab.toDate,
                });
                if (response && response.responseCode === 200 && response.data) {
                    setEmergencyPerformanceData(response.data);
                } else {
                    setEmergencyPerformanceData([]);
                }
            } finally {
                setEmergencyPerformanceLoading(false);
            }
        }
        fetchEmergencyPerformance();
    }, [emergencyPerformanceTab]);

    useEffect(() => {

        const fetchEmergencySites = () => {
            SiteAction.fetchSiteList({
                pageNo: 0,
                pageSize: 0,
                companyId: decryptAesObj(localStorage.getItem("data")).companyId,
            }).then((response) => {
                if (response != null) {
                    let sorted = response.sort((a, b) =>
                        a.name.localeCompare(b.name)
                    );

                    setEmergencySites(sorted);
                } else {
                    setEmergencySites([]);
                }
            });
        };

        // fetchEmergencySites();
    }, []);

    useEffect(() => {
        async function fetchMonthlyTripComparison() {
            setMonthlyLoading(true);
            try {
                const response = await AnalyticsDashoardAction.getMonthlyTripComparison({
                    emergencySiteId: selectedMonthlyEmergencySite?.siteId || null,
                });
                console.log("monthly comparison response", response);
                if (response && response.responseCode === 200 && response.data) {
                    const comparison = response.data.monthlyComparison || [];

                    const rows2025 = comparison.filter(d => Number(d.year) === 2025);
                    const rows2026 = comparison.filter(d => Number(d.year) === 2026);

                    const earlyMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
                    const lateMonths = ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    const earlyPart = rows2026
                        .filter(d => earlyMonths.includes(d.month))
                        .map(d => ({
                            monthLabel: d.month,
                            currentMonthTrips: d.currentTrips ?? 0,
                            prevMonthTrips: d.previousTrips ?? 0,
                        }));
                    const latePart = rows2025
                        .filter(d => lateMonths.includes(d.month))
                        .map(d => {
                            const match2026 = rows2026.find(r => r.month === d.month);
                            return {
                                monthLabel: d.month,
                                currentMonthTrips: match2026?.currentTrips ?? 0,
                                prevMonthTrips: d.currentTrips ?? 0,
                            };
                        });

                    const mapped = [...earlyPart, ...latePart];
                    setMonthlyData(mapped);
                }
            } catch (err) {
                console.log("error", err);
            } finally {
                setMonthlyLoading(false);
            }
        }

        fetchMonthlyTripComparison();
    }, [selectedMonthlyEmergencySite]);

    useEffect(() => {
        async function fetchYearlyTripComparison() {
            setYearlyLoading(true);
            try {
                const response = await AnalyticsDashoardAction.getYearlyTripComparison({
                    emergencySiteId: selectedYearlyEmergencySite?.siteId || null,
                });
                console.log("yearly comparison response", response);
                if (response && response.responseCode === 200 && response.data) {
                    const mapped = (response.data.yearlyComparison || []).filter(d => Number(d.year) >= 2025).map(d => ({
                        yearLabel: String(d.year),
                        currentYearTrips: d.currentTrips ?? 0,
                        prevYearTrips: d.previousTrips ?? 0,
                    }));
                    setYearlyData(mapped);
                }
            } finally {
                setYearlyLoading(false);
            }
        }

        fetchYearlyTripComparison();
    }, [selectedYearlyEmergencySite]);


    const handleEmergencyPerformanceTabChange = (newTab) => {
        setEmergencyPerformanceTab(newTab);
        setEmergencyPerformancePage(0);
    };


    const handlePerformanceTabChange = (newTab) => {
        setPerformanceTab(newTab);
        setPerformancePage(0);
    };

    if (!isDashboardVisible) {
        return (
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '80vh',
                gap: 2,
                // background: 'linear-gradient(135deg, #e8f4fd 0%, #f0f7ff 100%)',
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    // background: '#fff',
                    // borderRadius: 4,
                    // boxShadow: '0 4px 32px rgba(26,144,255,0.10)',
                    px: 8,
                    py: 6,
                    gap: 2,
                }}>
                    <Typography sx={{ fontSize: '80px', fontWeight: 800, color: '#061386', lineHeight: 1 }}>
                        403
                    </Typography>
                    <Typography sx={{ fontSize: '22px', fontWeight: 700, color: '#1a2a3a' }}>
                        Access Denied
                    </Typography>
                    <Typography sx={{ fontSize: '15px', color: '#7a8fa6', textAlign: 'center', maxWidth: 320 }}>
                        You don't have permission to access this page. Please contact your administrator.
                    </Typography>
                    <Box sx={{
                        mt: 1, px: 3, py: 0.8, borderRadius: 2, cursor: 'pointer',
                        background: 'linear-gradient(90deg, #061386 0%, #0066cc 100%)',
                        color: '#fff', fontWeight: 600, fontSize: '14px',
                        boxShadow: '0 2px 8px rgba(26,144,255,0.25)',
                        '&:hover': { opacity: 0.9 }, userSelect: 'none',
                    }}
                        onClick={() => window.history.back()}
                    >
                        ← Go Back
                    </Box>
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={styles.pageWrapper}>
            <DashboardHeader isTripDashboardVisible={isTripDashboardVisible} />
            <Box sx={{ margin: '20px 0px' }}>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={5}>
                        <LoadingOverlay loading={dataLoading}>
                            <VehicleStatusPanel data={data?.vehicleStatus} />
                        </LoadingOverlay>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <LoadingOverlay loading={dataLoading}>
                            <TripDetailsPanel data={data?.tripDetails} />
                        </LoadingOverlay>
                    </Grid>
                </Grid>

                <Grid container spacing={3} sx={{ mt: 0.5 }}>
                    <Grid item xs={12} md={6}>
                        <LoadingOverlay loading={weeklyLoading}>
                            <TripsWeeklyChart data={weeklyData?.weeklyTripComparison} />
                        </LoadingOverlay>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LoadingOverlay loading={weeklyLoading}>
                            <ActiveVehiclesChart data={weeklyData?.weeklyActiveVehicles} />
                        </LoadingOverlay>
                    </Grid>
                </Grid>

                <Grid container spacing={3} sx={{ mt: 0.5 }}>
                    <Grid item xs={12}>
                        <LoadingOverlay loading={weeklyLoading}>
                            <AvgTripsChart data={weeklyData?.weeklyAvgTripsPerVehicle?.map(d => ({
                                dayLabel: d.dayLabel,
                                avgCurrentWeek: d.avgCurrentWeek,
                                avgPrevWeek: d.avgPrevWeek,
                            }))} />
                        </LoadingOverlay>
                    </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mt: 0.5, justifyContent: 'space-between' }}>
                    {/* Monthly Chart - 70% width */}
                    <Grid item xs={12} md={12}>
                        <LoadingOverlay loading={monthlyLoading}>
                            <TripsMonthlyChart
                                data={monthlyData}
                                emergencySites={performanceData}
                                selectedEmergencySite={selectedMonthlyEmergencySite}
                                onEmergencySiteChange={setSelectedMonthlyEmergencySite}
                            />
                        </LoadingOverlay>
                    </Grid>

                    {/* Yearly Chart - 30% width */}
                    {/* <Grid item xs={12} md={12}>
                        <LoadingOverlay loading={yearlyLoading}>
                            <TripsYearlyChart
                                data={yearlyData}
                                emergencySites={performanceData}
                                selectedEmergencySite={selectedYearlyEmergencySite}
                                onEmergencySiteChange={setSelectedYearlyEmergencySite}
                            />
                        </LoadingOverlay>
                    </Grid> */}
                </Grid>

                {/* <Grid container spacing={3} sx={{ mt: 0.5 }}>
                    <Grid item xs={12}>
                        <LoadingOverlay loading={summerPlanLoading}>
                            <DJBSummerPlan
                                lowCoverageData={lowCoverageData}
                                lowCoveragePage={lowCoveragePage}
                                onLowCoveragePageChange={setLowCoveragePage}
                                summerPlanData={summerPlanData}
                                scheduledVsActualData={scheduledVsActualData}
                                summerPlanFilter={summerPlanFilter}
                                unverifiedDplData={unverifiedDplData}
                                onFilterChange={setSummerPlanFilter}
                                lowCoveragePageSize={lowCoveragePageSize}
                                onLowCoveragePageSizeChange={(size) => { setLowCoveragePageSize(size); setLowCoveragePage(0); }}

                            />
                        </LoadingOverlay>
                    </Grid>
                </Grid> */}
                <Grid container spacing={3} sx={{ mt: 0.5 }}>
                    <Grid item xs={12}>
                        <LoadingOverlay loading={emergencyPerformanceLoading}>
                            <EmergeancyPerformanceStatus
                                data={emergencyPerformanceData}
                                activeTab={emergencyPerformanceTab}
                                onTabChange={handleEmergencyPerformanceTabChange}
                                page={emergencyPerformancePage}
                                onPageChange={setEmergencyPerformancePage}
                                pageSize={perfPageSize}
                                onPageSizeChange={(size) => { setPerfPageSize(size); setEmergencyPerformancePage(0); }}
                            />
                        </LoadingOverlay>
                    </Grid>
                </Grid>

                <Grid container spacing={3} sx={{ mt: 0.5 }}>
                    <Grid item xs={12}>
                        <LoadingOverlay loading={performanceLoading}>
                            <PerformanceStatus
                                data={performanceData}
                                activeTab={performanceTab}
                                onTabChange={handlePerformanceTabChange}
                                page={performancePage}
                                onPageChange={setPerformancePage}
                                pageSize={performancePageSize}
                                onPageSizeChange={(size) => { setPerformancePageSize(size); setPerformancePage(0); }}
                            />
                        </LoadingOverlay>
                    </Grid>
                </Grid>



            </Box>
        </Box>
    );
};

export default AnalyticsDashboard;